import React, { useState } from 'react'

import { Button } from 'Components/shared/Button'
import Switch from 'Components/shared/Switch'
import Input from 'Components/shared/Input'
import { ErrorText, SuccessText } from 'Components/shared/Typography'

import { Flex } from 'lese'

import InvitesService from 'Services/invites'

import { useInput, runOnEnter } from 'Helpers'
import { SelectUsingButton } from 'Components/shared/Select'

const durationOptions = ['Unlimited', '24h', '2d', '7d', '14d', '30d']

function durationToDate(duration) {
  const date = new Date()
  if (duration === 'Unlimited') return undefined

  if (duration === '24h') date.setDate(date.getDate() + 1)
  if (duration[duration.length - 1] === 'd')
    date.setDate(date.getDate() + +duration.replace('d', ''))
  return date
}

export default ({ virtualOfficeId, onUpdate }) => {
  const [errorText, setErrorText] = useState()
  const [successText, setSuccessText] = useState()

  const [unlimitedUses, setUnlimitedUses] = useState(true)
  const maxUsesHook = useInput('')

  const [duration, setDuration] = useState(durationOptions[0])
  const [selection, setSelection] = useState(0)

  const createInvite = async () => {
    const invite = await InvitesService.create({
      virtualOfficeId,
      maxUses: unlimitedUses ? undefined : +maxUsesHook.value,
      expiresOn: durationToDate(duration)
    }).catch(err => setErrorText(err.message))
    if (!invite) return
    setSuccessText('Successfully added the invite')
    setErrorText('')

    if (typeof onUpdate !== 'function') return
    onUpdate()
  }

  return (
    <Flex column separation="24px" xAlign="center">
      <Flex yAlign separation="8px">
        <span>Unlimited Uses</span>
        <Switch checked={unlimitedUses} onChange={setUnlimitedUses} />
      </Flex>
      {!unlimitedUses && (
        <Input
          placeholder="Max Uses"
          type="number"
          {...maxUsesHook.bind}
          onKeyDown={runOnEnter(createInvite)}
          tabIndex={0}
        />
      )}
      <Flex yAlign separation="8px">
        <span>Expires In</span>
        <SelectUsingButton
          selection={selection}
          options={durationOptions}
          onChange={({ newIndex }) => {
            setDuration(durationOptions[newIndex])
            setSelection(newIndex)
          }}
        />
      </Flex>
      {errorText && <ErrorText>{errorText}</ErrorText>}
      {successText && <SuccessText>{successText}</SuccessText>}
      <Button onClick={createInvite}>Create Invite</Button>
    </Flex>
  )
}
